export interface Product {
  product_name: string;
  description: string;
  models: string[];
}

export interface ExistingProduct extends Product {
  id: string;
  created_at: string;
  updated_at: string;
  is_system_product: boolean;
}

export type UpdateProductPayload = {
  id: ExistingProduct["id"];
  fields?: Partial<Product>;
};

export const computeChangedFields: (e: ExistingProduct, p: Product) => Partial<Product> = (existing, product) => {
  const changed = {};
  Object.keys(product).forEach((key) => {
    if (Array.isArray(product[key]) && Array.isArray(existing[key])) {
      const existingSorted = existing[key].toSorted();
      const productSorted = product[key].toSorted();

      if (JSON.stringify(existingSorted) !== JSON.stringify(productSorted)) {
        changed[key] = product[key];
      }
    } else if (product[key] !== existing[key]) {
      changed[key] = product[key];
    }
  });

  return changed;
};
